import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import routes from "../routes/routes";

import { update as updateCurrentlyCapturing } from "../store/slices/currentlyCapturing";
import { update as updateRetake } from "../store/slices/retake";
import { update as updateSubject } from "../store/slices/subject";
import { update as updateMode } from "../store/slices/mode";

import Button from "../components/Button";

const StyledDiv = styled.div`
  padding: 0 1em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-wrap: nowrap;
`;

const DocumentButton = styled(Button)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 0.65em 0 0;
  margin: 0;
  color: #fff;
  border: none;
  background: transparent;
  padding: 0;
  flex-shrink: 0;
  overflow: hidden;
  width: auto;
  max-width: 50%;
  max-height: 100%;
  &:hover,
  &:focus {
    background: transparent;
    color: #fff;
  }
  & + & {
    margin: 0 0 0 0.65em;
  }
`;

const BottomLabel = styled(Button)`
  margin: 0.75em 0.5em 0;
  padding: 0.6em;
  font-size: 1em;
  text-transform: none;
  background: ${(props) => props.theme.color.black};
  width: 100%;
  border-radius: 16px;
  font-weight: normal;
  &:hover,
  &:focus {
    background: ${(props) => props.theme.color.black};
    color: #fff;
  }
`;

const GhostLabel = styled(BottomLabel)`
  border: 1px solid ${(props) => props.theme.color.gray};
  background: transparent;
  color: ${(props) => props.theme.color.gray};
  &:hover,
  &:focus {
    background: transparent;
    color: ${(props) => props.theme.color.gray};
  }
`;

const StyledHeading = styled.h2`
  font-size: 1.25em;
  text-transform: none;
  color: ${(props) => props.theme.color.black};
`;

const StyledImage = styled.img`
  max-height: 37%;
  max-width: 100%;
`;

const Gallery = ({ documentList, ...rest }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const showSpinner = useSelector((state) => state.showSpinner.value);

  const retakePicture = (document) => {
    // console.log("retaking", document);
    // set everything up to retake the type of pic the user clicked on
    dispatch(updateRetake(true));
    dispatch(updateSubject(document.docType));
    dispatch(updateMode(document.modeUsed));
    dispatch(updateCurrentlyCapturing(document.documentCaptured));
    history.push(routes.instructions);
  };

  const imageList = documentList().map((document, index) => {
    return (
      <DocumentButton
        key={index}
        type="button"
        onClick={() => retakePicture(document)}
      >
        {documentList().length > 1 ? (
          <StyledHeading>{document.label}</StyledHeading>
        ) : null}
        <StyledImage src={document.image} alt={document.documentCaptured} />
        {showSpinner ? (
          <GhostLabel as="div">Retake photo</GhostLabel>
        ) : (
          <BottomLabel as="div">Retake photo</BottomLabel>
        )}
      </DocumentButton>
    );
  });

  return <StyledDiv {...rest}>{imageList}</StyledDiv>;
};

export default Gallery;
